import ToastHighLighter from '@/lib/ToastHighLighter';

export const TableCodeStriped = () => {
  const language = 'html';
  const codeString = `
  // Table striped
  <table class="table table-striped table-hover table-responsive">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">First</th>
        <th scope="col">Last</th>
        <th scope="col">Handle</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th scope="row">1</th>
        <td>Mark</td>
        <td>Otto</td>
        <td>@mdo</td>
      </tr>
      <tr>
        <th scope="row">2</th>
        <td>Jacob</td>
        <td>Thornton</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">3</th>
        <td colSpan={2}>Larry the Bird</td>
        <td>@twitter</td>
      </tr>
    </tbody>
  </table>`;

  return (
    <>
      <ToastHighLighter
        name={'tablestriped'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const TableCodeNormal = () => {
  const language = 'html';
  const codeString = `
  // Table striped
  <table class="table table-hover table-responsive">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">First</th>
        <th scope="col">Last</th>
        <th scope="col">Handle</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th scope="row">1</th>
        <td>Mark</td>
        <td>Otto</td>
        <td>@mdo</td>
      </tr>
      <tr>
        <th scope="row">2</th>
        <td>Jacob</td>
        <td>Thornton</td>
        <td>@fat</td>
      </tr>
      <tr>
        <th scope="row">3</th>
        <td colSpan={2}>Larry the Bird</td>
        <td>@twitter</td>
      </tr>
    </tbody>
  </table>`;

  return (
    <>
      <ToastHighLighter
        name={'tablenormal'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
